import { useState, useEffect } from "react";
import { useDataProvider } from "react-admin";

const useCoupons = () => {
  const [coupons, setCoupons] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();

  useEffect(() => {
    async function fetchAll() {
      try {
        const coupons = await dataProvider.getList("coupons", {});
        setCoupons(coupons.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError(error);
      }
    }
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    coupons,
    loading,
    error,
  };
};

export default useCoupons;
